import Link from 'next/link'
import React, { useRef, useState } from 'react'
import { useContext, useEffect } from 'react'
import { MainContext } from '../../contexts/MainContext'
import BlogSection from '../Home/Blog/BlogSection'
import axios from 'axios'
import { API_BASE_URL } from '../../lib/constants'
import { useRouter } from 'next/router'
import { DarkLoader } from '../CustomElements/Loader/Loader'
import style from './BlogsSection.module.css'

export interface DataProps {
	length: number
	image: string
	id: number
	name: string
	short_content: string
	publish_date: string
	slug: string
}

interface PostsProps {
	current_page: number
	total: number
	data: DataProps[]
}

interface SearchProps {
	posts_totals: number
	per_page: number
	posts: PostsProps
}

interface SectionProps {
	searchBlogs: SearchProps
	currentFilter: string
	setsearchBlogs: (data: SearchProps) => void
	setCurrentFilter: (type: string) => void
}

const BlogsSection = (props: SectionProps) => {
	const { setIsLoading, redirectTo } = useContext(MainContext)
	// const [currentFilter, setCurrentFilter] = useState("");
	const [maxButtons, setMaxButtons] = useState(4)
	const [loadingNews, setLoadingNews] = useState(false)
	const [loadingBlog, setLoadingBlog] = useState(false)

	let num: number = props?.searchBlogs?.posts_totals / props?.searchBlogs?.per_page
	if (num - parseInt(num?.toString()) > 0) {
		num = parseInt(num?.toString()) + 1
	}
	let paging = {
		counts: num,
		window: 1,
		current: props?.searchBlogs?.posts?.current_page,
		start: 1,
		end: num
	}

	const range = (start: number, end: number, maxButtons: number, step = 1) => {
		let output = []
		if (typeof end === 'undefined') {
			end = start
			start = 0
		}
		for (let i = start; i <= end && output.length < maxButtons; i += step) {
			output.push(i)
		}
		return output
	}

	const paginateFunc = (url: string, pageNumber: number = paging?.counts) => {
		if (pageNumber <= paging?.counts && pageNumber >= 1) {
			redirectTo(url)
		}
	}

	const fetchFilteredBlogs = (type: string) => {
		axios
			.get(`${API_BASE_URL}blog-filter?type=${type}`)
			.then((res) => {
				if (props?.searchBlogs !== undefined) {
					props?.setsearchBlogs(res?.data)
				}
				props?.setCurrentFilter(type)
				setLoadingNews(false)
				setLoadingBlog(false)
			})
			.catch((err) => {})
	}

	const handleFilterButton = (type: string) => {
		if (type === props?.currentFilter) {
			fetchFilteredBlogs('')
			if (type === 'news') {
				setLoadingBlog(false)
				setLoadingNews(true)
			} else if (type === 'blog') {
				setLoadingNews(false)
				setLoadingBlog(true)
			}
		} else {
			if (type === 'news') {
				setLoadingNews(true)
				setLoadingBlog(false)
			} else {
				setLoadingBlog(true)
				setLoadingNews(false)
			}
			fetchFilteredBlogs(type)
		}
	}

	useEffect(() => {
		setIsLoading(false)
	}, [setIsLoading, props])

	const router = useRouter()
	const [searchValue, setSearchValue] = useState('')
	const [isLoadingbtn, setIsLoadingbtn] = useState(false)
	const inputRef = useRef<HTMLInputElement | null>(null)

	const blogSearchApiHandler = async (value: string) => {
		setIsLoadingbtn(true)
		const type = props?.currentFilter || 'all'
		const res = await axios.get(`${API_BASE_URL}blog-search?value=${value}&type=${type}`)
		props?.setsearchBlogs(res?.data)
		setIsLoadingbtn(false)
	}

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value)
		const value = e.target.value
		if (!value.trim()) {
			blogSearchApiHandler('')
		}
	}

	const handleSvgClick = async () => {
		const searchKeyword = inputRef?.current?.value?.trim()
		const type = props?.currentFilter
		if (searchKeyword) {
			await blogSearchApiHandler(searchKeyword)
			router.push(`/blog?search=${encodeURIComponent(searchKeyword)}&type=${type}`)
		} else {
			router.push('/blog')
		}
	}

	const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSvgClick()
		}
	}
	if (paging?.window / paging?.current <= paging?.current) {
		paging.start = paging?.current - 1
		if (paging?.start < 1) {
			paging.start = 1
		}
		paging.end = paging?.start + 3
	}
	if (paging?.end > paging?.counts) {
		paging.end = paging?.counts
	}

	const renderLoader = () => {
		if (isLoadingbtn) {
			return (
				<div className='  absolute right-1 top-6  cursor-pointer p-1   transform -translate-y-1/2 ' role='status'>
					<DarkLoader loaderType='sml' className='ml-[7px]' />
				</div>
			)
		}
		return (
			<svg xmlns='http://www.w3.org/2000/svg' className=' h-8 w-8 right-0 top-6  absolute   cursor-pointer p-1  transform -translate-y-1/2' fill='none' viewBox='0 0 26 26' stroke='#777' onClick={handleSvgClick}>
				<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={1} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
			</svg>
		)
	}

	useEffect(() => {
		const width = window.matchMedia('(min-width: 320px)')

		const updateMaxButtons = (e) => {
			if (e.matches) {
				setMaxButtons(4)
			} else {
				setMaxButtons(3)
			}
		}

		width.addEventListener('resize', updateMaxButtons)

		return () => width.removeEventListener('resize', updateMaxButtons)
	}, [])

	console.log('props?.currentFilter', props?.currentFilter)

	return (
		<div className='Cart-page relative'>
			<div className='cart-page-container width mt-5 md:mt-14 mb-7 md:mb-28'>
				<div className='flex flex-wrap justify-between gap-4'>
					<div>
						<h1 className='text-2xl lg:text-3xl sm:text-3xl font-bold'>{props?.currentFilter === 'news' ? 'News' : 'Blog'} </h1>
						<p className='text-black-500 mt-3 text-[15px]'>{props?.searchBlogs && props?.searchBlogs?.posts && props?.searchBlogs?.posts?.total > 0 && `${props?.searchBlogs?.posts?.total} Results`}</p>
					</div>

					<div className={`flex flex-wrap  justify-between ${style.searchBlogsMain} gap-3`}>
						<div className='breadcrumb  text-black leading-snug bread-leading relative '>
							<input
								type='search'
								placeholder={`Search ${props?.currentFilter === 'news' ? 'News' : props?.currentFilter === 'blog' ? 'Blogs' : 'Blogs & News'}`}
								value={searchValue}
								onChange={handleInputChange}
								onKeyPress={handleKeyPress}
								ref={inputRef}
								className={` blogsearch  pr-10 p-3 focus:outline-none  rounded-lg lite-blue-bg-color text-gray-600  ${style.widerInput}   `}
							/>
							{renderLoader()}
						</div>
						<div></div>

						<div className='mt-1 '>
							<button className={`mr-3 ${style.newsbtn} leading-btn bg-transparent text-blue-400 font-semibold   py-2 px-4 border  rounded ${props?.currentFilter === 'news' ? style.activenews : ''}`} onClick={() => handleFilterButton('news')} disabled={loadingBlog}>
								{loadingNews ? (
									<div className='flex items-center'>
										News
										<DarkLoader loaderType='sml' className='ml-[7px]' />
									</div>
								) : (
									'News'
								)}
							</button>
							<button className={`${style.blogsbtn} bg-transparent font-semibold  py-2 px-4 border  rounded  ${props?.currentFilter === 'blog' ? style.activeblogs : ''}`} style={{ color: '#0078b6' }} onClick={() => handleFilterButton('blog')} disabled={loadingNews}>
								{loadingBlog ? (
									<div className='flex items-center'>
										Blog
										<DarkLoader loaderType='sml' className='ml-[7px]' />
									</div>
								) : (
									'Blog'
								)}
							</button>
						</div>
					</div>
				</div>

				<section className='blog'>
					<div className='flex flex-col lg:flex-row'>
						<div className='blogs-wrapper flex flex-col w-full'>
							<div className={`${style.blogsImgsContainer} grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 mt-6  gap-6`}>
								{props?.searchBlogs?.posts !== undefined && props?.searchBlogs?.posts?.data?.length > 0 ? (
									props?.searchBlogs?.posts?.data?.map((recentBlog: DataProps) => {
										return <BlogSection key={recentBlog?.id} blog={recentBlog} />
									})
								) : (
									<div className='text-lg text-red-500    '>No result found</div>
								)}
							</div>
						</div>
					</div>
					{paging?.counts > 1 ? (
						<div className='flex m-2 mt-8 md:mt-10 overflow-hidden flex-wrap gap-y-2  w-max rounded border border-solid border-gray-300'>
							{/* Got to start of page */}
							{paging?.start >= 1 && (
								<div className={`border-l border-solid border-gray-300 px-3 py-2 cursor-pointer paging-hover`} onClick={() => paginateFunc(`/blog?page=1`, 1)}>
									<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
										<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 19l-7-7 7-7m8 14l-7-7 7-7' />
									</svg>
								</div>
							)}

							{/* Go to prev page */}
							<div className={`border-l border-solid border-gray-300 p-2 cursor-pointer paging-hover`} onClick={() => paginateFunc(`/blog?page=${paging?.current - 1}`, paging?.current - 1)}>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 19l-7-7 7-7' />
								</svg>
							</div>

							{range(paging?.start, paging?.end, maxButtons)?.map((num: number, index: number) => {
								return (
									<Link key={index} href={`/blog?page=${num}`}>
										<a className='paging-hover'>
											<div className={`border-l border-solid border-gray-300 px-3 py-2 cursor-pointer ${paging?.current == num ? 'paging active text-white shadow-lg' : ''}`} onClick={() => setIsLoading(true)}>
												{num}
											</div>
										</a>
									</Link>
								)
							})}

							{/* Go to next page */}
							<div className={`border-l border-r border-solid border-gray-300 p-2 cursor-pointer paging-hover`} onClick={() => paginateFunc(`/blog?page=${Number(paging?.current) + 1}`, Number(paging?.current) + 1)}>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
								</svg>
							</div>

							{/* Got to end of page */}
							{paging?.end <= paging?.counts && (
								<div className={`px-3 py-2 cursor-pointer paging-hover`} onClick={() => paginateFunc(`/blog?page=${paging?.counts}`, paging?.counts)}>
									<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
										<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 5l7 7-7 7M5 5l7 7-7 7' />
									</svg>
								</div>
							)}
						</div>
					) : (
						''
					)}
				</section>
			</div>
		</div>
	)
}

export default BlogsSection
